import { Box, Button } from "@mui/material";

import { seriesOrder, useSeriesColors } from "./chartSeries";

export function SeriesToggle({
  visibleSeries,
  setVisibleSeries,
}: {
  visibleSeries: string[];
  setVisibleSeries: React.Dispatch<React.SetStateAction<string[]>>;
}) {
  const seriesColors = useSeriesColors();

  return (
    <div className="flex flex-row flex-wrap items-center justify-center gap-1">
      {seriesOrder.map((series, index) => {
        const isVisible = visibleSeries.includes(series);

        return (
          <Button
            key={series}
            aria-pressed={isVisible}
            color="inherit"
            onClick={() =>
              setVisibleSeries((currentSeries) =>
                isVisible
                  ? currentSeries.filter((visibleSeriesName) => visibleSeriesName !== series)
                  : [...currentSeries, series],
              )
            }
            size="small"
            startIcon={
              <Box
                sx={{
                  bgcolor: isVisible ? seriesColors[index] : "transparent",
                  border: `2px solid ${seriesColors[index]}`,
                  borderRadius: 0.5,
                  height: 16,
                  width: 16,
                }}
              />
            }
            sx={{
              textDecoration: isVisible ? "none" : "line-through !important",
            }}
          >
            {series}
          </Button>
        );
      })}
    </div>
  );
}
